import type { RisksWithAncestorContributorsAndEntitiesResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetRisksWithAncestorContributorsAndEntitiesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRisksWithAncestorContributorsAndEntitiesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetRisksWithAncestorContributorsAndEntities = createQueryHook<
  Record<string, never>,
  RisksWithAncestorContributorsAndEntitiesResponseRow[],
  GetRisksWithAncestorContributorsAndEntitiesQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.risk.risksWithAncestorContributorsAndEntities.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ risk: data }),
  graphqlDocument: GetRisksWithAncestorContributorsAndEntitiesDocument,
});
